import { environment } from '../../environments/environment';

export class eQMSScopeConstants{
    public static readonly eQMSScopeManagementTitle = "eQMS Scope";
    public static readonly eQMSScope_RoleAcessPermission_Fail: string = "Unable to fetch Roles permission";
    public static readonly eQMSScopeManagementTitle_For_Edit = "Edit eQMS Scope";
    public static readonly eQMSScopeManagementTitle_For_Create = "Create eQMS Scope";
    public static readonly eQMSScopeHierarchyUpdateTitle = "Update eQMS Scope Hierarchy";

    public static readonly infoForSourceItaag: string = 'Select the source ITAAG for this eQMS Scope';
    public static readonly infoForForbidChanges: string = 'Document metadata and Proficiency Quiz are not modifiable after the transition to Client Signature / In Review Phases, except for the Assigned Admin';

    public static readonly Scope_Slider_Confirmation_Text: string =
    'Any unsaved change will be lost when closing the screen. Do you want to continue?';
     public static readonly Scope_Slider_Confirmation_Header: string =
    'Confirmation';
    public static readonly Scope_Slider_Duplicate_Scope_Name_Error: string =
    'Two eQMS Scope having a same parent eQMS Scope cannot have the same name.';

    public static readonly Scope_Slider_Create_Success_Message: string =
    'eQMS Scope created successfully.';

    public static readonly Scope_Slider_Update_Success_Message: string =
    'eQMS Scope updated successfully.';

    public static readonly Scope_Bulk_User_Update_Success_Message: string =
    'Users added successfully to the selected scope.';

    public static readonly Severity_Success:string = "success";
    public static readonly Severity_Err: string = 'error';
    public static readonly Scope_Slider_Create_Error_Message: string = 'Failed to create scope';
    public static readonly Scope_Slider_Update_Error_Message: string = 'Failed to update scope';
    public static readonly Scope_Bulk_User_Update_Error_Message: string = 'Failed to update bulk user scope.';
    public static readonly Scope_Slider_No_Scope_Selected_Error_Message: string = 'No scope selected for update';

    // API Endpoints - Administration
    public static readonly Scope_Update_Url: string = `${environment.urls.apis.administration}scope/{scopeId}`;
    public static readonly Global_Itaags_Api: string = `${environment.urls.apis.administration}itaag/getGlobalItaags/{operationType}`;
    public static readonly Scope_Categories_Api: string = `${environment.urls.apis.administration}scope/getScopeCategories`;
    public static readonly Scope_Create_Url: string = `${environment.urls.apis.administration}scope`;
    public static readonly Get_Parent_Scope_Url: string = `${environment.urls.apis.administration}scope/getAvailableParentScopes`;
    public static readonly Scope_Audit_Trail_Url: string = `${environment.urls.apis.administration}scopeaudit`;
    public static readonly Scope_Bulk_User_Update_Url: string = `${environment.urls.apis.administration}UserContext/bulk-scope-selection`;
}
